
import { accommodationMapping } from '../mappings/AccommodationMapping';

export const applyAccommodationFilter = (dbQuery: any, accommodationType: string) => {
  const accommodationKeywords = accommodationMapping[accommodationType as keyof typeof accommodationMapping];
  
  if (!accommodationKeywords || accommodationKeywords.length === 0) {
    console.log('No keywords found for accommodation type:', accommodationType);
    return dbQuery;
  }
  
  console.log('Applying accommodation filter for:', accommodationType);
  console.log('Using keywords:', accommodationKeywords);
  
  // Voor vakantiehuis en bijzondere accommodaties zoeken we ook in description
  if (accommodationType === 'vakantiehuis' || accommodationType === 'bijzonder') {
    const typeConditions = accommodationKeywords.map(keyword => 
      `typeAccommodatie.ilike.%${keyword}%`
    ).join(',');
    
    const descriptionConditions = accommodationKeywords.map(keyword => 
      `description.ilike.%${keyword}%`
    ).join(',');
    
    const nameConditions = accommodationKeywords.map(keyword => 
      `name.ilike.%${keyword}%`
    ).join(',');
    
    const allConditions = [typeConditions, descriptionConditions, nameConditions].join(',');
    
    console.log('Generated extended OR conditions for', accommodationType, ':', allConditions);
    return dbQuery.or(allConditions);
  }
  
  // Voor andere accommodatietypes alleen in typeAccommodatie zoeken
  const orConditions = accommodationKeywords.map(keyword => 
    `typeAccommodatie.ilike.%${keyword}%`
  ).join(',');
  
  console.log('Generated OR conditions:', orConditions);
  
  return dbQuery.or(orConditions);
};
